import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';

export function replaceNestedWithId(obj, fieldName) {
  if (obj[fieldName] === undefined || obj[fieldName] === null) {
    return obj;
  }
  const transformedObject = omit(obj, [fieldName]);
  transformedObject[`${fieldName}Id`] = obj[fieldName].id;
  return transformedObject;
}

export function replaceNestedWithIds(obj, fieldName, renameField = true) {
  if (isEmpty(obj[fieldName])) {
    return obj;
  }
  const transformedObject = omit(obj, [fieldName]);
  const idsFieldName = renameField ? `${fieldName.slice(0, -1)}Ids` : fieldName;
  transformedObject[idsFieldName] = obj[fieldName].map(o => o.id);
  return transformedObject;
}

export function enrichNestedWithId(obj, fieldName) {
  if (obj[fieldName] === undefined || obj[fieldName] === null) {
    return obj;
  }
  return { ...obj, [`${fieldName}Id`]: obj[fieldName].id };
}
